import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import PropTypes from 'prop-types';

export default function CustomToggleButton({ title = "", buttons, selected, handleClick = (value) => false }) {
  const handleToggle = (_, value) => {
    if (value === null) return;
    handleClick(value)
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      {title !== "" ? <Typography
        variant="subtitle2"
        color="textSecondary"
        style={{ paddingRight: 8 }}
      >
        {title}
      </Typography> : null}
      <ToggleButtonGroup
        value={selected}
        exclusive
        onChange={handleToggle}
        aria-label="toggle button group"
        size="small"
      >
        {buttons.map(button =>
          <ToggleButton key={button.id} value={button.id} aria-label={button.id}>
            <Typography variant="button">
              {button.title}
            </Typography>
          </ToggleButton>
        )}
      </ToggleButtonGroup>
    </div>
  );
}

ToggleButton.propTypes = {
  title: PropTypes.string,
  buttons: PropTypes.arrayOf(PropTypes.object),
}